// Card #1652 (design §6.1) — position -> judge name(s). Renders
// `judgesPositions` exactly as score-common's judgesPositionsOf composed it:
// `[{ position, judges: [name, ...] }]`.
//
// Tolerant of FVD's concatenated two-judges-one-booth strings
// (docs/score/fvd-data-model.md's "Two judges at one booth = both last
// names concatenated (NOT garbled)"): a shared booth arrives as ONE string
// in `judges` holding both names, e.g. "Williams Koch". This component does
// not parse, split, or otherwise try to be clever about that string — it
// renders whatever is in the array as-is, joined with ", " only when the
// array itself genuinely holds more than one entry. Trying to "fix" a
// two-name string (splitting on a space, truncating, re-titlecasing) would
// silently mangle a real judge's name, which is exactly what
// fvd-data-model.md warns against.
import "./JudgeLine.css";

// Card #1948 (WEC demo parity, card #1928) — leads with a JUDGES label so
// the row announces what it is to an audience that does not know the
// dressage judge letters, and accents the position letter (C/E/B/H/M) with
// the theme's accent color so it reads as a label, not as an initial
// attached to the judge's name. Row-per-position rendering (and therefore
// card #1343's composite-judge "both judges shown" behaviour) is unchanged.
export default function JudgeLine({ judgesPositions }) {
  if (!Array.isArray(judgesPositions) || !judgesPositions.length) return null;

  return (
    <div className="judge-line" data-testid="judge-line">
      <span className="judge-line__label" data-testid="judge-line-label">
        Judges
      </span>
      <ul className="judge-line__rows">
        {judgesPositions.map(({ position, judges }) => (
          <li key={position} className="judge-line__row" data-testid="judge-line-row">
            <span className="judge-line__position" data-testid="judge-line-position">
              {position}
            </span>
            <span className="judge-line__names" data-testid="judge-line-names">
              {(judges || []).join(", ")}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
